import request, { put } from './httpService';

const base = '/document';

export const DocumentService = {
  listByCustomer(customerId, signal) {
    return request({
      method: 'GET',
      url: `${base}/customer/${customerId}`,
      signal: signal
    }).then(res => {
      // Return in consistent format with { data: [...], count: ... }
      if (res.data && !Array.isArray(res.data)) {
        return res.data; // Already in { data, count } format
      }
      return { data: res.data || [], count: res.data?.length || 0 };
    });
  },

  getById(id, signal) {
    return request({
      method: 'GET',
      url: `${base}/${id}`,
      signal: signal
    }).then(res => res.data);
  },

  create(customerId, fileData) {
    const formData = new FormData();
    formData.append('customerId', customerId);
    formData.append('files', fileData.file);
    formData.append('documentTypes', JSON.stringify([fileData.documentType || 'other']));
    formData.append('descriptions', JSON.stringify([fileData.description || '']));

    return request({
      method: 'POST',
      url: `${base}/new`,
      data: formData,
    }).then(res => res.data);
  },

  createBulk(customerId, filesArray) {
    const formData = new FormData();
    formData.append('customerId', String(customerId));
    
    // Add all files
    filesArray.forEach(fileData => {
      formData.append('files', fileData.file);
    });
    
    // Add metadata as JSON arrays
    formData.append('documentTypes', JSON.stringify(
      filesArray.map(f => f.documentType || 'other')
    ));
    formData.append('descriptions', JSON.stringify(
      filesArray.map(f => f.description || '')
    ));

    // Don't set Content-Type header - let axios/browser handle it with boundary
    return request({
      method: 'POST',
      url: `${base}/new`,
      data: formData,
    }).then(res => res.data);
  },

  update(id, { description, documentType }) {
    return request({
      method: 'PUT',
      url: `${base}/${id}`,
      data: { description, documentType },
    }).then(res => res.data);
  },

  delete(id) {
    return request({ method: 'DELETE', url: `${base}/${id}` }).then(res => res.data);
  },

  download(attachmentId) {
    return request({
      method: 'GET',
      url: `${base}/attachment/${attachmentId}/download`,
      responseType: 'blob',
    }).then(res => res.data);
  },
};
